import Modal from '../../../scripts/modal'
import merge from "lodash.merge";
import SiteMessagesInstance from '../../../components/site-messages'

const DeleteSensor = (settings = {}) => {

  settings = merge({
    class: ['group-modal', 'form-modal'],
    title: 'Delete Sensor',
    sensor: null,
  }, settings)

  const sensor = settings.sensor;
  const modal = new Modal(settings);

  modal.setContent(`

    <form data-form="delete_sub_account" class="grid-container">
        
    <div class="grid-x grid-margin-x form-modal__row">
      <div class="cell medium-2">Sensor ID</div>
      <div class="cell medium-8">
        <p class="text--bold">${sensor.sensor_id}</p>
      </div>
    </div>
    
    <div class="grid-x grid-margin-x form-modal__row">
      <div class="cell medium-2">Name</div>
      <div class="cell medium-8">
        <p class="text--bold">${sensor.sensor_name}</p>
      </div>
    </div>
    
    <p><strong>You are about to permanently delete this sensor from your account.</strong> 
    This action will erase all sensor readings, alerts, and historical data. 
    <strong>This cannot be undone.</strong></p> <p><strong>Important:</strong> 
    You <em>do not</em> need to delete a sensor to change its WiFi settings, move it to a different account, or reset 
    and reconnect it. If you intend to update WiFi, reconnect, or transfer the sensor, please follow the steps at 
    <a href="${window.site.home}/setup">Setup & Reconnect Instructions</a> instead.</p> 
    <p>Only proceed if you are absolutely certain you want to permanently delete all associated data and 
    remove the sensor from your account.</p>

    <div class="form-modal-actions">
      <div class="form-modal-actions__submit">
        <button type="submit" class="button" style="margin-right: 20px;" data-for="okay">Delete</button>
        <button type="button" class="button gray" data-for="cancel">Cancel</button>
        <div class="error-message">Hello I'm an error</div>
      </div>
    </div>
    </form>
  `);

  const $modalContainer = $(modal.getContainer());

  const $form = $modalContainer.find('form');
  const $error = $modalContainer.find('.error-message');

  $form.on('submit', e => {

    e.preventDefault();
    $form[0].disabled = true;

    $error.removeClass('is-visible');

    window.apiRequest('post', `/sensor/${sensor.sensor_id}/delete`).then(async r => {

      $form[0].disabled = false;

      if (r.type === 'error') {

        $error.html(r.message);
        $error.addClass('is-visible');

      } else {
        SiteMessagesInstance.addMessage("success", `You have successfully deleted the sensor <b>${sensor.sensor_id}</b>`)
        window.location.reload();
      }

    });

  });

  $modalContainer.on('click', '.button[data-for="cancel"]', () => {
    modal.close();
  });

  modal.open();

}

export default DeleteSensor;
